import(/* webpackMode: "eager" */ "/var/www/luaitools.com/app/tools/[id]/detail.css");
;
import(/* webpackMode: "eager" */ "/var/www/luaitools.com/app/tools/[id]/related.css");
;
import(/* webpackMode: "eager" */ "/var/www/luaitools.com/app/tools/[id]/hero-actions.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/luaitools.com/components/LikeButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/luaitools.com/components/SiteHeader.tsx");
